/** @jsx jsx */
import { jsx } from "@emotion/react";
import { FC, useState } from "react";
import NoFooterModal from "../NoFooterModal";
import FlowioTextarea from "../../../atoms/inputs/FlowioTextarea";
import ConfirmationButtons from "../ConfirmationModal/ConfirmationButtons/ConfirmationButtons";
import { inputCss, invalidInputCss, modalCss } from "./styles";
import { applyCss } from "../../../../utils/emotion";

export type Props = {
  isOpen: boolean;
  toggleModal: () => void;
  title: string;
  placeholder?: string;
  initialValue?: string;
  required?: boolean;
  onAccept(value: string): void;
};

const TextInputModal: FC<Props> = ({
  isOpen,
  toggleModal,
  title,
  placeholder,
  initialValue = "",
  onAccept,
  required = false,
}) => {
  const [value, setValue] = useState(initialValue);

  const isValueInvalid = required && !value;

  return (
    <NoFooterModal
      title={title}
      isOpen={isOpen}
      toggle={toggleModal}
      css={modalCss}
    >
      <p>
        <FlowioTextarea
          placeholder={placeholder}
          value={value}
          onChange={setValue}
          css={applyCss([inputCss, isValueInvalid && invalidInputCss])}
        />
      </p>
      <ConfirmationButtons
        onAccept={() => !isValueInvalid && onAccept(value)}
        onDecline={toggleModal}
      />
    </NoFooterModal>
  );
};

export default TextInputModal;
export type TextInputModalProps = Props;
